import { call, put, takeEvery } from "redux-saga/effects";
import { GET_RIDEDETAILSPOLYLINE } from "resources/actionTypes";
import { rideDetailsPolyLines } from "services/LiveTripService";

function* fetchRideDetailsPolyLines(action) {
    try {
      const payload = action.payload || {};
      const userRideDetails = yield call(rideDetailsPolyLines, payload);
      yield put({
        type: GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_SUCCESS,
        userRideDetails: userRideDetails,
      });
    } catch (e) {
      yield put({ type: GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_FAILED, message: e.message });
    }
  }
  export function* rideDetailsPolylineSaga() {
    yield takeEvery(GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_REQUESTED, fetchRideDetailsPolyLines);
  }